var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settings)?_c('v-form',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}}),_c('v-col',{staticClass:"text-right"},[_c('BaseButton',{on:{"click":_vm.saveSettings}},[_vm._v(" "+_vm._s(_vm.$t("common.save"))+" ")])],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }